import React from "react";

import { Table, Tag, Typography } from "antd";
import PropTypes from "prop-types";

const UsersTable = ({ data }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (text) => (
        <Typography.Text strong={!text} ellipsis={{ tooltip: true }}>
          {text || <span style={{ color: "#ff4d4f" }}>Missing</span>}
        </Typography.Text>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
      render: (text) => (
        <Typography.Text strong={!text} ellipsis={{ tooltip: true }}>
          {text || <span style={{ color: "#ff4d4f" }}>Missing</span>}
        </Typography.Text>
      ),
    },
    {
      title: "Host",
      dataIndex: "host",
      key: "host",
      width: 150,
      render: (text) => (
        <Typography.Text strong={!text} ellipsis={{ tooltip: true }}>
          {text || <span style={{ color: "#ff4d4f" }}>Missing</span>}
        </Typography.Text>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status, record) => (
        <div>
          <Tag
            color={status === "valid" ? "green" : "red"}
            style={{ marginBottom: record.error ? 4 : 0 }}
          >
            {status.toUpperCase()}
          </Tag>

          {record.error && (
            <Typography.Paragraph
              type="danger"
              className="error-message"
              style={{ marginBottom: 0 }}
            >
              {record.error}
            </Typography.Paragraph>
          )}
        </div>
      ),
    },
  ];

  // const validCount = data.filter((item) => item.status === "valid").length;
  // const invalidCount = data.length - validCount;

  return (
    <div className="users-table">
      <div className="table-header">
        <Typography.Text strong className="table-title">
          Uploaded users ({data.length})
        </Typography.Text>

        {/* <div className="count-summary">
          <span className="valid-count">Success: {validCount}</span>

          {invalidCount > 0 && (
            <span className="invalid-count">Failed: {invalidCount}</span>
          )}
        </div> */}
      </div>

      <div className="table-container">
        <Table
          size="small"
          dataSource={data}
          columns={columns}
          pagination={false}
          scroll={{ y: 300 }}
          rowKey={(record, index) => `${record.email || "unknown"}_${index}`}
          rowClassName={(record) =>
            record.status === "valid" ? "valid-row" : "invalid-row"
          }
          locale={{
            emptyText: "No users uploaded yet",
          }}
        />
      </div>
    </div>
  );
};

UsersTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      host: PropTypes.string,
      status: PropTypes.string,
      error: PropTypes.string,
    })
  ).isRequired,
};

export default UsersTable;
